import type { JiraStatus } from '@shared/types.js';

// Jira lozenge colors per status category
const categoryStyles: Record<string, string> = {
  new: 'bg-gray-200/80 text-gray-700',
  indeterminate: 'bg-blue-100 text-blue-800',
  done: 'bg-green-100 text-green-800',
  undefined: 'bg-gray-200/80 text-gray-700',
};

interface StatusBadgeProps {
  status: JiraStatus;
  size?: 'sm' | 'md';
}

export function StatusBadge({ status, size = 'sm' }: StatusBadgeProps) {
  const style = categoryStyles[status.category] || categoryStyles.undefined;
  const sizeClass = size === 'sm' ? 'px-1.5 py-px text-[11px]' : 'px-2 py-0.5 text-xs';

  return (
    <span
      className={`inline-flex max-w-full items-center whitespace-nowrap rounded-[3px] font-bold uppercase tracking-wide ${style} ${sizeClass}`}
      title={status.name}
    >
      <span className="truncate">{status.name}</span>
    </span>
  );
}
